<template>
  <div id="app">
    <KoExc />
  </div>
</template>

<script>
import KoExc from "./KoExc";

export default {
  name: 'app',
  components: {
    KoExc,
  }
}
</script>
